// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__2cRKm","label":"CategoryService_label__UeRFc","location":"CategoryService_location__37OPp"};